export const LOGIN_ERROR = '您的電子郵件帳號或密碼錯誤，請重新輸入';
export const SIGNUP_ERROR = '註冊失敗';
export const EMAIL_ALREADY_IN_USED = '您輸入的電子郵件帳號已被註冊，請重新輸入';
export const FORGET_PASSWORD_ERROR = '您輸入的電子信箱未被註冊';
